import { Component, Host, Prop, h } from '@stencil/core';
export type IcoContent = 'primary' | 'secondary' | 'base';

@Component({
  tag: 'ico-hyperlink',
  styleUrl: 'ico-hyperlink.css',
})
export class IcoHyperlink {
  @Prop() href: HTMLAnchorElement['href'] = '#';
  @Prop() htmlTitle: HTMLElement['title'] = '';
  @Prop() content: IcoContent = 'base';
  @Prop() noUnderline = false;
  @Prop() target: HTMLAnchorElement['target'] = '_self';
  @Prop() rel: HTMLAnchorElement['rel'] = '';
  @Prop() testId: string = '';

  render() {
    const classes = {
      'ico-hyperlink': true,
      'ico-hyperlink--on-dark': this.content === 'primary',
      'ico-hyperlink--no-underline': this.noUnderline,
    };

    return (
      <Host>
        <a data-testid={this.testId} class={classes} href={this.href} target={this.target} title={this.htmlTitle} rel={this.rel}>
          <slot></slot>
        </a>
      </Host>
    );
  }
}
